import React, { FC, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import TableTab from "../components/tabs/table-tab";
import { USER_PERMISSIONS } from "../constants/menu-types";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import { TranslationKeys } from "../contexts/TranslationKeys";
import { Category } from "../models/Category";
import columns from '../models/ColumnDefinitions/PermissionColumn';
import { Lookup } from "../models/Lookup";
import LookupTypes from "../models/LookupTypes";
import searchColumns from '../models/search/PermissionSearch';
import SiteSearch from "../models/search/SiteSearch";
import { DeleteEntityResult } from "../models/services/DeleteEntityResult";
import { deletePermission, getPermissions } from "../services/permissionService";
import { getSiteNamesWithPagination } from "../services/siteService";
interface Props {
    setBusy: (isBusy: boolean) => void,
    categories: Category[],
    setCategories: (category: Category[]) => void
}

const PermissionsTab: FC<Props> = ({ setBusy, categories, setCategories }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.permissions);
    const itemPath = '/access-control/operators/permission/';
    const [lookup, setLookup] = useState<Lookup[]>([]);
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const currentMenuDetail = USER_PERMISSIONS;
    const USER_DEFINED_TEMPLATE_KEY = 1;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail) => void) => {
        setDetails(userLoginId, currentMenuDetail);
    }
    const userLoginProfileId = useSelector((state: any) => (state.userInfo.profileId));

    useEffect(() => {
        (async () => {
            setLookup([{
                name: LookupTypes.site,
                values: [],
                dataMethod: getSiteNamesWithPagination,
                searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
            }]);
        })();
    }, [])

    const onDelete = (id: string): Promise<DeleteEntityResult> => {
        setBusy(true);
        return new Promise((resolve, reject) => {
            deletePermission(id)
                .then(
                    deleteResult => {
                        resolve(deleteResult);
                        setCategories([{ ...categories[0], count: (categories[0]?.count ?? 1) - 1 }]);
                        setBusy(false);
                    },
                    deleteResult => {
                        reject(deleteResult);
                        setBusy(false);
                    })
        });
    }

    return <TableContextProvider
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        dataMethod={listParameters => getPermissions(translate, listParameters, userLoginProfileId )}
        tableDescriptor={columns}
        searchDescriptor={searchColumns}
        // deleteMethod={onDelete} - Will be enabled on upcoming releases
        useTable
        usePagination
        useSearch
        useSort
        useFilter
        lookup={lookup}
        customDelete={{ fieldName: "templateKey", comparisonValue: USER_DEFINED_TEMPLATE_KEY }} 
        showAddNewButton={false}>
        <TableTab
            title={title}
            selectRows={false}
            rowPath={itemPath}
            cyName="permissions" />
    </TableContextProvider>
};

export default PermissionsTab;
